import { Box, Tooltip, Typography, Tabs, Tab } from '@mui/material';

type TableType = "Zusammenfassung" | "Alle Daten";
interface TableViewProps {
    value: TableType;
    onChange: (value: TableType) => void;
    isDisabled?: boolean;
}
const TableViewSelector: React.FC<TableViewProps> = ({ value, onChange, isDisabled }) => {
    return (
        <Box sx={{ borderColor: 'divider', padding: 0 , margin: 0 }}>
            <Tabs value={value} onChange={(_, newValue) => onChange(newValue as TableType)} aria-label="Tabellenansicht">
                <Tab 
                    value="Alle Daten" 
                    label={<Typography variant="body2" sx={{ fontSize: 12, fontFamily: "Inter" }}>Alle Daten</Typography>}
                    sx={{ height: 40 }}
                />
                {isDisabled ? (
                    <Tooltip title="Diese Option ist für dieses Diagramm nicht verfügbar." placement="top">
                        <span>
                            <Tab 
                                label={<Typography variant="body2" sx={{ fontSize: 12, fontFamily: "Inter" }}>Zusammenfassung</Typography>}
                                value="Zusammenfassung"
                                sx={{ height: 40 }}
                                disabled
                            />
                        </span>
                    </Tooltip>
                ) : (
                    <Tab
                        label={<Typography variant="body2" sx={{ fontSize: 12, fontFamily: "Inter" }}>Zusammenfassung</Typography>}
                        value="Zusammenfassung"
                        sx={{ height: 40 }}
                    />
                )}
            </Tabs>
        </Box>
    )
}

export default TableViewSelector;